import {
  Tenant as Icon
} from 'components/icons';

export const meta = {
  id: 'TenantsDetails',
  title: 'TenantsDetails',
  category: '',
  unique: false,
  icon: Icon,
  version: '1.0.0',
  description: `The tenants CRUD manager module`,
  windowOptions: {
    // if not passed, will be centered
    // x: null,
    // y: null,
    width: 440,
    height: 640
  }
};
